module.exports = __webpack_public_path__ + "img/logo.ee0bf846.svg";